module.exports = __webpack_public_path__ + "assets/filter-sort.3d0df6e8.svg";